import { StructuredDataSchemaItem } from '@repo/shared/dtos/structured-data'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@repo/ui/dialog'
import { useT } from '@repo/ui/hooks'
import { ScrollArea } from '@repo/ui/scrollArea'
import { useState } from 'react'

import { ItemBooleanForm } from '@/components/admin/structure-data/schema/forms/ItemBooleanForm'
import { ItemDateForm } from '@/components/admin/structure-data/schema/forms/ItemDateForm'
import { ItemEnumForm } from '@/components/admin/structure-data/schema/forms/ItemEnumForm'
import { ItemMultiselectForm } from '@/components/admin/structure-data/schema/forms/ItemMultiselectForm'
import { ItemNumberForm } from '@/components/admin/structure-data/schema/forms/ItemNumberForm'
import { ItemStringForm } from '@/components/admin/structure-data/schema/forms/ItemStringForm'

export function ItemEditor({
  item,
  onClose,
  onUpdate,
}: {
  item: StructuredDataSchemaItem | null
  onClose: () => void
  onUpdate: (item: StructuredDataSchemaItem) => void
}) {
  const { tc, t } = useT({ keyPrefix: 'admin.structuredData.types' })
  const [open, setOpen] = useState(item !== null)
  const handleUpdate = (updatedItem: StructuredDataSchemaItem) => {
    onUpdate(updatedItem)
    setOpen(false)
    onClose()
  }
  if (!item) return null
  const Form = () => {
    switch (item.type) {
      case 'string':
        return <ItemStringForm item={item} onUpdate={handleUpdate} />
      case 'boolean':
        return <ItemBooleanForm item={item} onUpdate={handleUpdate} />
      case 'number':
        return <ItemNumberForm item={item} onUpdate={handleUpdate} />
      case 'date':
        return <ItemDateForm item={item} onUpdate={handleUpdate} />
      case 'enum':
        return <ItemEnumForm item={item} onUpdate={handleUpdate} />
      case 'multiselect':
        return <ItemMultiselectForm item={item} onUpdate={handleUpdate} />
      default:
        return null
    }
  }
  return (
    <Dialog
      open={open}
      onOpenChange={(v) => {
        if (!v) onClose()
        setOpen(v)
      }}
    >
      <DialogContent className="px-0 xl:px-0" disableOutsideClick>
        <DialogHeader className="px-4 xl:px-6">
          <DialogTitle>{tc('edit', { cfl: true })}</DialogTitle>
          <DialogDescription>
            {tc('type', { cfl: true, colon: true })}{' '}
            <span className="font-medium">{t(item.type)}</span>
          </DialogDescription>
        </DialogHeader>

        <ScrollArea className="max-h-[75vh] overflow-y-auto px-4 xl:px-6">
          <Form />
        </ScrollArea>
      </DialogContent>
    </Dialog>
  )
}
